import React from "react";
import queryString from "query-string";
import { useHistory } from "react-router-dom";
import { Tabs } from "antd";
import get from "lodash/get";
import LiveStreamVideo from "../../organisms/LiveStreamingVideo";
import LiveStreamingChat from "../../organisms/LiveStreamingChat";
import LiveStreamingProducts, {
  ProductStatus,
} from "../../organisms/LiveStreamingProducts";
import { StatusLive } from "../../../models/liveStream";
import styles from "./LiveStreamView.module.scss";
import { isMobileOrTablet } from "../../../common-definitions/device";
import { getDuration } from "../../../common-definitions/moment-utils";
import { Program, CreateProgramInput } from "../../../API";
import { ProgramData } from "../../../context/program";
import { useViewport } from "../../../hooks/useViewport";

const { TabPane } = Tabs;

interface LiveStreamVideoProps {
  programProducts: ProgramData[] | null;
  program: Program;
  createReaction: (isRehearsal: 0 | 1) => void;
  handleGoProductDetailExternal: (data: CreateProgramInput) => void;
  fetched: boolean;
  cartInList: Program[];
  isShowStatusProduct: boolean;
  onPlayVideoArchived: () => void;
}

const LiveStreamView: React.FC<LiveStreamVideoProps> = ({
  programProducts,
  program,
  createReaction,
  handleGoProductDetailExternal,
  fetched,
  cartInList,
  isShowStatusProduct,
  onPlayVideoArchived,
}) => {
  const history = useHistory();
  const search =
    queryString.parse(history?.location?.search || "") || ({} as any); // eslint-disable-line
  const isMobile = useViewport() <= 1024 || isMobileOrTablet();
  const refTab = React.useRef<HTMLDivElement>(null);
  const refVideo = React.useRef<HTMLDivElement>(null);
  const [state, setState] = React.useState({
    enableScrollDown: true,
    activeTab: "1",
  });
  const [statusLive, setStatusLive] = React.useState(StatusLive.live);

  const handleChangeStatus = (status: StatusLive) => {
    setStatusLive(status);
  };

  const isVideoMode = search.viewmode && search.viewmode === "video";

  return (
    <div
      className={`${styles.container} ${
        program?.lineAddFriendBtnHtml ? styles.resizePadding : null
      }`}
    >
      {!isMobile ? (
        <div className={styles.content}>
          <div className={styles.inner}>
            <div
              className={`${styles.video} ${
                isVideoMode ? styles.videoFullWidth : ""
              }`}
            >
              <LiveStreamVideo
                program={program}
                createReaction={createReaction}
                handleChangeStatus={handleChangeStatus}
                fetched={fetched}
                isVideoMode={!!isVideoMode}
                programProductList={programProducts || []}
                onPlayVideoArchived={onPlayVideoArchived}
              />
            </div>
            {!isVideoMode ? (
              <div className={styles.chat}>
                <LiveStreamingChat
                  program={program}
                  statusLive={statusLive}
                  fetched={fetched}
                />
              </div>
            ) : null}
          </div>
          {!isVideoMode ? (
            <div className={styles.products}>
              <LiveStreamingProducts
                program={program}
                programProductList={programProducts || []}
                statusLive={statusLive}
                fetched={fetched}
                handleGoProductDetailExternal={handleGoProductDetailExternal}
                cartInOfProgram={cartInList}
                isShowStatusProduct={isShowStatusProduct}
              />
            </div>
          ) : (
            <div className={styles.linkDetailWrap}>
              <a
                target="_blank"
                rel="noreferrer"
                href={history?.location?.pathname}
                className={styles.linkDetail}
              >
                商品購入やコメント投稿はこちら
              </a>
            </div>
          )}
        </div>
      ) : (
        <div className={styles.contentOfSP}>
          <div className={styles.video} ref={refVideo}>
            <LiveStreamVideo
              program={program}
              createReaction={createReaction}
              handleChangeStatus={handleChangeStatus}
              fetched={fetched}
              isVideoMode={!!isVideoMode}
              programProductList={programProducts || []}
              onPlayVideoArchived={onPlayVideoArchived}
            />
          </div>
          <div className={`tabs-info-mobile ${styles.tabs}`} ref={refTab}>
            <Tabs
              defaultActiveKey={isVideoMode ? "3" : "1"}
              onChange={(key) =>
                setState({
                  ...state,
                  activeTab: key,
                })
              }
            >
              {!isVideoMode ? (
                <>
                  <TabPane
                    key="1"
                    tab={
                      <span className={styles.introProductTab}>
                        紹介商品
                        <span className={styles.tag}>
                          {
                            programProducts?.filter((pr) =>
                              pr.productStatusUpdateAt?.startsWith(
                                ProductStatus.ON
                              )
                            ).length
                          }
                        </span>
                      </span>
                    }
                  >
                    <LiveStreamingProducts
                      programProductList={programProducts || []}
                      statusLive={statusLive}
                      program={program}
                      fetched={fetched}
                      handleGoProductDetailExternal={
                        handleGoProductDetailExternal
                      }
                      cartInOfProgram={cartInList}
                      isShowStatusProduct={isShowStatusProduct}
                    />
                  </TabPane>
                  <TabPane tab="コメント" key="2">
                    <LiveStreamingChat
                      program={program}
                      statusLive={statusLive}
                      fetched={fetched}
                    />
                  </TabPane>
                </>
              ) : null}
              <TabPane tab="番組概要" key="3">
                <div className={styles.infoLive}>
                  <p className={styles.title}>{program.programName}</p>
                  <p className={styles.brand}>
                    {get(program.customer, "items[0].companyName", "")}
                  </p>
                  <p className={styles.timeLive}>
                    配信日：
                    {getDuration(
                      program.livestreamStartDateTime,
                      program.livestreamEndDateTime
                    )}
                  </p>
                  <div className={styles.description}>
                    {program.programDescription}
                  </div>
                  {isVideoMode ? (
                    <div className={styles.linkDetailWrap}>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={history?.location?.pathname}
                        className={styles.linkDetail}
                      >
                        商品購入やコメント投稿はこちら
                      </a>
                    </div>
                  ) : null}
                </div>
              </TabPane>
            </Tabs>
          </div>
        </div>
      )}
    </div>
  );
};

export default LiveStreamView;
